import FieldConfig from "../../../proto/field-config"
import FieldCurrency from "../../../generic/finance/currency/currency"
import FieldItemModelCalculatedServiceCost_TableCell from "./render/table/table-cell"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type";

export default class FieldItemModelCalculatedServiceCost extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Service cost"
        this.label                                  = "Service cost"

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelCalculatedServiceCost_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelCalculatedServiceCost_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    let res = 0

                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    if (listItem.view.isCollapsed &&
                        !!calculatedValues?.total?.value &&
                        calculatedValues?.total.value > calculatedValues?.own) {
                        res = calculatedValues?.total.value || 0
                    } else {
                        res = calculatedValues?.own || 0
                    }
                    return res
                }
            ],
            directions  : [sort]
        }
    }
}
